import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';

import Dialog from '../Dialog';
import { Typography } from '../Wrappers/Wrappers';
import { useStyles } from './otpSuccessDialog.styles';
import TickCircleOutline from './tickCircleOutline.svg?react';

function OTPSuccessDialog ({ open, onClose }) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick
      PaperProps={{
        classes: {
          root: classes.dialogContainer,
        },
      }}
    >
      <Grid className={classes.content}>
        <TickCircleOutline aria-hidden="true" />
        <Typography variant={'h5'} weight={'medium'} className={classes.successTitle}>
          OTP Verification successfull
        </Typography>
        <Button
          variant="contained"
          className={classes.okButton}
          onClick={onClose}
        >
          OK
        </Button>
      </Grid>
    </Dialog>
  );
}

OTPSuccessDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

OTPSuccessDialog.defaultProps = {
  open: false,
  onClose: () => {},
};

export default observer(OTPSuccessDialog);
